<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>洗车监管系统</el-breadcrumb-item>
        <el-breadcrumb-item>票券管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <hx-table-result :show-pager-on-one-page="false" :loading="tableLoading">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button class="align-left" type="primary" size="small" @click="toCreate"> 新增 </el-button>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column prop="ticketsType" align="center" label="票券类型"> </el-table-column>

        <el-table-column prop="ticketsPrice" align="center" label="票券价格">
          <template slot-scope="scope">
            <span>￥ {{ scope.row.ticketsPrice }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="editItem(scope.row)">编辑</el-button>
            <confirm-button type="text" style="margin: 0 10px" title="确认要删除该条数据？" @confirmed="deleteItem(scope.row.id)">
              <span>删除</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>

    <el-dialog class="hx-to-create-template" :title="dialogTitle" :visible.sync="dialogVisible" width="40%" @close="resetDialogForm" :close-on-click-modal="false">
      <div>
        <el-form ref="dialogForm" :model="itemParams" :rules="checkItemParams" label-width="120px">
          <el-form-item label="票券类型 ：" prop="ticketsType">
            <el-input v-model="itemParams.ticketsType" size="small" placeholder="请填写票券类型"> </el-input>
          </el-form-item>

          <el-form-item label="票券价格：" prop="ticketsPrice">
            <el-input-number size="small" v-model="itemParams.ticketsPrice" :min="1"> </el-input-number>
          </el-form-item>

          <el-form-item>
            <el-button :disabled="isDisabled" size="small" type="primary" @click="saveItem('dialogForm')"> 保 存 </el-button>

            <el-button size="small" @click="dialogVisible = false"> 取 消 </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      carWashId: "",
      tableLoading: false,
      tableData: [],
      isDisabled: false,
      dialogTitle: "",
      dialogVisible: false,
      itemParams: {
        ticketsType: "",
        ticketsPrice: 1,
      },
      url: "",
      method: "",
      checkItemParams: {
        ticketsType: [{ required: true, message: "请填写票券类型", trigger: "blur" }],
        ticketsPrice: [{ required: true, message: "请输入票券价格", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.carWashId = this.$route.params.carWashId;
    this.loadTableData();
  },
  methods: {
    /**
     * 加载列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/coupons/list?carWashId=" + this.carWashId,
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 新增票券
     */
    toCreate() {
      this.itemParams.ticketsType = "";
      this.itemParams.ticketsPrice = 1;
      this.dialogTitle = "新增票券";
      if (this.itemParams.id) {
        delete this.itemParams.id;
      }
      this.dialogVisible = true;
      this.method = "POST";
      this.url = "/coupons/save";
    },
    /**
     * 编辑条目数据
     * @param row
     */
    editItem(row) {
      this.dialogTitle = "编辑票券";
      Object.assign(this.itemParams, row);
      this.dialogVisible = true;
      this.method = "PUT";
      this.url = "/coupons/update";
    },
    /**
     * 删除条目数据
     * @param id
     */
    deleteItem(id) {
      this.$http({
        url: global.apiUrl + "/coupons/delete?id=" + id + "&carWashId=" + this.carWashId,
        method: "DELETE",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 保存条目数据
     * @param name
     */
    saveItem(name) {
      this.isDisabled = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          const bodyParams = Object.assign(this.itemParams, {
            carWashId: this.carWashId,
          });
          this.$http({
            url: global.apiUrl + this.url,
            method: this.method,
            body: bodyParams,
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.isDisabled = false;
                this.dialogVisible = false;
                this.$message.success(res.body.info);
                this.loadTableData();
              } else {
                this.isDisabled = false;
              }
            })
            .catch(err => {
              this.isDisabled = false;

              console.error(err);
            });
        } else {
          this.isDisabled = false;
        }
      });
    },
    /**
     * 关闭对话框时重置表单
     */
    resetDialogForm() {
      this.$refs.dialogForm.resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
